module.exports = __webpack_public_path__ + "static/first-friday-f7c6dab7fd06b716d84eef09075fe560.mp4";